import { OrderDto } from './index';
import { Customer, Discount, NumberPorting, Package } from '@webmodule-order/api';
import { computed, signal } from '@angular/core';
import { PackageOption } from './PackageOption';
import { addWeeks, format } from 'date-fns';

export enum PaymentInterval {
  monthly = 'monthly',
  quarterly = 'quarterly',
  yearly = 'yearly',
}

export type PaymentIntervalType = 'monthly' | 'quarterly' | 'yearly';

type TvTypes = 'itv' | 'itvBoxType' | 'itvBox' | 'tvOptions';
type PhoneTypes = 'landline' | 'numberPorting' | 'extraPhoneLine' | 'phoneUnlimited' | 'extraNumberPorting';

export type OrderDiscType = 'internet' | TvTypes | PhoneTypes | 'mobile';

export class Order implements OrderDto {
  customer!: Customer;
  discounts: Array<Discount> = [];
  feePayment: PaymentIntervalType = PaymentInterval.monthly;
  feePaymentDelivery: 'monthly' | 'buyout' | 'none' = 'monthly';
  numberPortings: Array<NumberPorting> = [];
  package!: Package;
  instalationHelp = false;
  phoneUnlimited?: boolean;
  noPhone?: boolean;
  preOrder = false;
  wishDate: string = format(addWeeks(new Date(), 2), 'yyyy-MM-dd');
  reseller?: string;
  secondPhoneLine?: boolean;
  withItv?: boolean;
  withTvBox?: boolean;
  tvOptions = signal<PackageOption[]>([]);
  packageOptionsMap = new Map<string, PackageOption | null>();
}

export class CreateOrder implements OrderDto {
  customer!: Customer;
  package!: Package;
  discounts: Array<Discount> = [];
  feePayment: PaymentIntervalType = PaymentInterval.monthly;
  feePaymentDelivery: 'monthly' | 'buyout' | 'none' = 'monthly';
  numberPortings: Array<NumberPorting> = [];
  instalationHelp = false;
  noPhone = false;
  preOrder = false;
  wishDate: string = format(addWeeks(new Date(), 2), 'yyyy-MM-dd');
  reseller = '';
  withItv = false;
  withTvBox = false;
}

export class OrderState {
  internet = signal<boolean>(false);
  tv = signal<boolean>(false);
  phone = signal<boolean>(false);
  mobile = signal<boolean>(true);

  isOrderable = computed(() => this.internet() && this.tv() && this.phone());
}
